module.exports = __webpack_public_path__ + "img/Loverly_Preview_VisionBoard.47a0d4e.jpg";